import React, { Suspense } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { GohubLogo } from "../common/icons/GohubLogo"
import { EdenredLogo } from "../common/icons/EdenredLogo";

const useStyles = makeStyles((theme) => ({
	fullContainer: {
		zIndex: "999",
    position: "fixed",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    opacity: "0.6",
    backgroundColor: "rgba(250,250,250, 0.9)",
	},
  container: {
		width: "100%",
		height: "100%"
	},
  centralize: {
		animation: "pulse 2s ease-in infinite",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
		zIndex: "99999",
    transform: "translate3d(0, -150px, 0)"
  },
  text: {
    marginTop: "1rem"
  }
}));
const Loader = (props) => {
	const classes = useStyles();
  const { text, full, edenredLogo } = props;

	return (
		<div className={full ? classes.fullContainer : classes.container}>
			<Suspense fallback={<div>Loading...</div>}>
        <div className={classes.centralize}>
          <div className={classes.logo}>
            { edenredLogo ? <EdenredLogo /> : <GohubLogo /> }

            { text && (<p className={classes.text}>{ text || 'Loading...' }</p>) }
          </div>
        </div>
			</Suspense>
		</div>
	);
};

export default Loader;
